import React from 'react';
import {connect} from "react-redux";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsDataTable from "components/data-table/BsDataTable";
import BsTabPanel from "components/panel/BsTabPanel";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import LABEL_ADMIN_CUSTOMER_SUPPORT_TABLE from "./label-admin-customer-support-table";
import {loadLabelMaintenanceIssue} from "core/actions/maintenance-actions";
import LabelAdminCustomerSupportFilters from "./LabelAdminCustomerSupportFilters";

const queryString = require('query-string');

class LabelAdminCustomerSupport extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        status: query.status != null ? (typeof query.status === "string" ? [query.status] : query.status) : [],
        systemName: query.systemName != null ? query.systemName : ''
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.status = this.state.fields.status;
    params.systemName = this.state.fields.systemName;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.status;
    delete params.systemName;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        status: [],
        systemName: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadLabelMaintenanceIssue(this.props.match.params.labelId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/label/' + this.props.match.params.labelId + '/admin/' + this.props.match.params.userId
      + '/reported-problem-info/' + row.id)
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    } else {
      query.sort = 'lastModifiedAt,desc';
    }

    if (query.status) {
      query.status = query.status instanceof Array ? query.status.join(',') : query.status;
    }

    if (query.systemName) {
      query['system.name'] = query.systemName;
    }

    query['assignee.id'] = this.props.match.params.userId;

    return query
  }

  render() {
    return (
      <BsTabPanel>
        <BsPanelLoader show={this.props.loading}/>
        <BsPanelHeader>
          <BsPanelTitle/>
        </BsPanelHeader>

        <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                              onHandleClear={this.onHandleClear.bind(this)}>
          <LabelAdminCustomerSupportFilters fields={this.state.fields}
                                            onHandleChange={this.handleChange.bind(this)}/>
        </BsPanelHeaderFilters>

        <BsDataTable location={this.props.location}
                     history={this.props.history}
                     order={this.state.direction}
                     orderBy={this.state.sort}
                     settings={LABEL_ADMIN_CUSTOMER_SUPPORT_TABLE}
                     content={this.props.issues}
                     onRowClick={this.onRowClick}
                     onChangePage={this.onLoadData}
                     onChangeSize={this.onLoadData}
                     onRequestSort={this.onRequestSort}/>
      </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    issues: state.maintenance.labelIssues,
    loading: state.clientUser.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadLabelMaintenanceIssue: (labelId, query) => {
      dispatch(loadLabelMaintenanceIssue(labelId, query));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelAdminCustomerSupport);
